import { axiosHub } from '@/services/config/axiosHub.config';

import { EventFailureDTO, FetchEventPaginatedOptionsDTO, PaginatedEventFailureDTO } from './types';

const fetchPaginated = async (params: FetchEventPaginatedOptionsDTO) => {
  const response = await axiosHub.get<PaginatedEventFailureDTO>(
    '/api/v1/notifications/event-failures',
    { params }
  );

  return response.data;
};

const getOne = async (id: string) => {
  const response = await axiosHub.get<EventFailureDTO>(
    `/api/v1/notifications/event-failures/${id}`
  );
  return response.data;
};

const requestRetry = async (id: string) => {
  const response = await axiosHub.patch<EventFailureDTO>(
    `/api/v1/notifications/event-failures/${id}/retry`
  );
  return response.data;
};

const ignoreEvent = async (id: string) => {
  const response = await axiosHub.patch<EventFailureDTO>(
    `/api/v1/notifications/event-failures/${id}/ignore`
  );
  return response.data;
};

export const EventFailureAPI = {
  fetchPaginated,
  getOne,
  requestRetry,
  ignoreEvent
};
